import { useWorkflow } from 'hooks/queries/workflow/useWorkflow'
import { WorkflowProvider } from './WorkflowProvider'
import { PropsWithChildren } from 'react'
import { ErrorBoundary } from '@sentry/react'

interface Props {
  articleId: string
  folderId: string
}

const WorkflowProviderContainer = ({ articleId, folderId, children }: PropsWithChildren<Props>) => {
  const { data, isError } = useWorkflow({ folderId })

  if (isError) {
    throw new Error(`unable to load workflow for folder: ${folderId}`)
  }

  return (
    <WorkflowProvider workflow={data?.workflow} articleId={articleId}>
      {children}
    </WorkflowProvider>
  )
}

const WorkflowProviderContainerWithError = ({ children, ...props }: PropsWithChildren<Props>) => (
  <ErrorBoundary fallback={<>{children}</>}>
    <WorkflowProviderContainer {...props}>{children}</WorkflowProviderContainer>
  </ErrorBoundary>
)

export { WorkflowProviderContainerWithError as WorkflowProviderContainer }
